import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "cashflowrecordgroups",
    defaultRoutePath: "/cashflows/cashflowrecordgroup",
    menuItemScope: "cashflows",
    menuItemName: "cashflowrecordgroups",
    routes: [
        {
            path: "/cashflows/cashflowrecordgroup",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
